import { IconLetter } from '@smartbear/swagger-portal-component-library'

import { CommonSearchResultTile, HighlightedTitle } from '../CommonSearchResultTile'
import { SearchResult } from '~/portal/types/search'

interface MessageSearchResultTileProps {
  result: SearchResult
  onClose: () => void
  tileKey: string
}

export const MessageSearchResultTile = ({ result, onClose, tileKey }: MessageSearchResultTileProps) => {
  const url = `/${result.product.slug}/${result.href}#/default/message-${result.messageId}`

  const icon = (
    <span className="mt-px">
      <IconLetter />
    </span>
  )

  const titleContent = (
    <div>
      <span className="font-semibold text-(--sp-method-message)">MESSAGE</span>
      {' / '}
      <HighlightedTitle titleSnippet={result.titleSnippet} removeLeadingSlash={!result.summary} />
    </div>
  )

  return (
    <CommonSearchResultTile
      result={result}
      onClose={onClose}
      tileKey={tileKey}
      icon={icon}
      url={url}
      titleContent={titleContent}
    />
  )
}